import { render, staticRenderFns } from "./paragraph-view.vue?vue&type=template&id=0afb8b8a&scoped=true&"
import script from "./paragraph-view.vue?vue&type=script&lang=js&"
export * from "./paragraph-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb8b8a",
  null
  
)

export default component.exports